var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#DCEAFB",
    stroke: "#B6D4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3133 26.6667C18.7861 26.6667 19.98 25.4728 19.98 24C19.98 22.5272 18.7861 21.3333 17.3133 21.3333C15.8406 21.3333 14.6467 22.5272 14.6467 24C14.6467 25.4728 15.8406 26.6667 17.3133 26.6667Z",
    stroke: "#1373E7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.98 24V14.6667",
    stroke: "#1373E7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 13.4067L24.6867 14.3867C25.4 14.6267 25.9867 15.4333 25.9867 16.1867V16.9667C25.9867 17.9867 25.2 18.5533 24.2333 18.2333L21.2867 17.2533C20.5733 17.0133 19.9867 16.2067 19.9867 15.4533V14.6667C19.98 13.6533 20.7733 13.08 21.74 13.4067Z",
    stroke: "#1373E7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioContent);
export default __webpack_public_path__ + "static/media/AudioContent.bf50bfb710ec64c8296df12a2242ee41.svg";
export { ForwardRef as ReactComponent };